import TradingStrategyProvider from "../provider/TradingStrategyProvider";

export default {
  state: {
    strategies: null,
    loading: false,
  },
  getters: {
    getTradingStrategy: (state) => state.strategies,
    getTradingStrategyLoading: (state) => state.loading,
  },
  actions: {
    fetchTradingStrategy({ commit }) {
      commit("SET_TS_LOADING", true);
      TradingStrategyProvider.getTradingStrategy()
        .then((res) => {
          let payload = res.data.tradingStrategy.data;
          if (typeof payload === "string") {
            payload = JSON.parse(payload.replaceAll("\\", ""));
          }
          commit("SET_TS", payload);
        })
        .catch((err) => {
          console.error("tradingStrategy query failed", err);
          commit("SET_TS", null);
        })
        .finally(() => commit("SET_TS_LOADING", false));
    },
  },
  mutations: {
    SET_TS(state, data) {
      state.strategies = data;
    },
    SET_TS_LOADING(state, value) {
      state.loading = value;
    },
  },
};
